// ---------------------------------
// client/src/pages/AdminPdfTemplatePreview.jsx
// Admin preview flow for PDF template prefills
// ---------------------------------
import React from 'react';
import { useParams } from 'react-router-dom';
import PdfFormFill from './PdfFormFill';

export default function AdminPdfTemplatePreview() {
    const { id } = useParams();
    return <PdfFormFill previewTemplateId={id} previewMode />;
}
